import { Vue, Component, Prop } from 'vue-property-decorator';
import { IModalComponent, Btn, Field, TextareaField } from '@samc/centricity-core';
import { IAddLoansToDealRequest, IDeal } from '@/Interfaces';
import { DealDropdownField } from '@/Components/Dropdowns';

@Component({
  name: 'allocate-loans-to-deal-modal',
  components: { TextareaField, Btn, Field, DealDropdownField }
})
export default class AllocateLoansToDealModal extends Vue implements IModalComponent {
  @Prop() public addCloseProp!: (callback: () => Promise<any>) => void;
  @Prop() public closeProp!: () => void;
  @Prop({ default: [] }) public loanIds!: number[];

  @Prop({ default: null }) public deals!: IDeal[] | null;

  public dealId: string = '';
  public description: string = '';

  public get loanString(): string {
    return this.loanIds.length > 1 ? 'loans' : 'loan';
  }

  public mounted() {
    this.addCloseProp(async () => {
      const messages: string[] = [];

      if (this.dealId.length === 0)
        messages.push(`Please select a deal to allocate the selected ${this.loanString}.`);

      if (messages.length === 0)
        return { dealId: this.dealId, description: this.description, newLoans: this.loanIds } as IAddLoansToDealRequest;

      this.$alert({
        title: 'Validation Errors Occurred',
        description: 'Please read below for details',
        type: 'error',
        errors: messages.slice(0, 10)
      });
    });
  }
}